import { registerDashboard } from '../registryCore';
import { createWidgetGroup, num, setState, } from '../helpers';
import { getActiveDashboard } from '../theme';
import { installChartRebuild } from '../charts/core/refresh';
registerDashboard('calendar', function (props, app) {
    var group = createWidgetGroup(app, 'calendar', props);
    installChartRebuild(group, app, buildCalendar);
    return group;
});
function buildCalendar(group, app, props) {
    var width = num(props, 'width', 210);
    var height = num(props, 'height', 0);
    var year = num(props, 'year', new Date().getFullYear());
    var month = num(props, 'month', new Date().getMonth());
    var highlightDay = num(props, 'highlightDay', -1);
    var first = new Date(year, month, 1);
    var daysInMonth = new Date(year, month + 1, 0).getDate();
    var startDay = first.getDay();
    var numRows = Math.ceil((startDay + daysInMonth) / 7);
    var headerH = 36;
    var gridW = width - 8;
    var gridH = height > headerH ? height - headerH - 4 : numRows * 26;
    var cell = Math.max(14, Math.min(Math.floor(gridW / 7), Math.floor(gridH / numRows), 32));
    var contentH = headerH + numRows * cell;
    group.metadata.chartWidth = width;
    group.metadata.chartHeight = height > 0 ? height : contentH + 4;
    group.add(app.text({
        text: first.toLocaleString('default', { month: 'long', year: 'numeric' }),
        x: 4,
        y: 4,
        fontSize: Math.min(13, cell * 0.45),
        fontWeight: 'bold',
        fill: getActiveDashboard().text,
        listening: false,
    }));
    ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'].forEach(function (d, i) {
        group.add(app.text({
            text: d,
            x: i * cell + 4,
            y: 22,
            fontSize: Math.max(8, cell * 0.32),
            fill: getActiveDashboard().textDim,
            listening: false,
        }));
    });
    for (var day = 1; day <= daysInMonth; day++) {
        var cellIdx = startDay + day - 1;
        var col = cellIdx % 7;
        var row = Math.floor(cellIdx / 7);
        group.add(app.text({
            text: String(day),
            x: col * cell + Math.max(4, cell * 0.2),
            y: headerH + row * cell,
            fontSize: Math.max(9, cell * 0.38),
            fill: day === highlightDay ? getActiveDashboard().highlight : getActiveDashboard().text,
            listening: false,
        }));
    }
    setState(group, { width: width, height: height > 0 ? height : contentH + 4, year: year, month: month, highlightDay: highlightDay, cell: cell });
}
